import PropTypes from "prop-types";

import Banner from "@shared/v2/Banner";

const InvalidAddressModalBody = ({ streetAddress, secondaryAddress, city, locality, postalCode, country }) => (
  <div className="tw-flex tw-flex-col tw-gap-[24px]">
    <span className="tw-text-14d tw-text-gray-75">We couldn’t verify the address you entered. This may impact features like mailers, home value estimates, and more.</span>
    <Banner containerClassName='!tw-rounded-4px tw-bg-gray-5 tw-border-gray-10 tw-py-12px tw-px-16px tw-flex tw-flex-col tw-items-baseline tw-text-14d tw-text-gray-75' show>
      <b>Your Address:</b>
      <span>{`${streetAddress}${secondaryAddress ? `, ${secondaryAddress}` : ''}`}</span>
      <span>{[city, locality, postalCode, country]
        .filter(Boolean)
        .join(', ')}</span>
    </Banner>
    <span>Are you sure you want to continue?</span>
  </div>
);

export default InvalidAddressModalBody;

InvalidAddressModalBody.propTypes = {
  streetAddress: PropTypes.string.isRequired,
  secondaryAddress: PropTypes.string,
  city: PropTypes.string.isRequired,
  locality: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
};

InvalidAddressModalBody.defaultProps = {
  secondaryAddress: '',
};
